import { useMemo } from 'react';
import MarqueeItem from '../components/marquee/MarqueeItem';

const useMemoizedItems = (data) => {
  return useMemo(() => data.map((match, index) => (
    <MarqueeItem key={match.id || index} match={match} />
  )), [data]);
};

export default useMemoizedItems;